export class BodyEncoder {
  public static encode (body: any) {
    const str = []
    for (const key in body) {
      if (body.hasOwnProperty(key)) {
        str.push(encodeURIComponent(key) + '=' + encodeURIComponent(body[key]))
      }
    }
    return str.join('&')
  }
}
